import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import jobsData from '../data/jobsData';
import { slugify } from '../utils/slugify';

const Home = () => {
  useEffect(() => {
    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^=\"#\"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }, []);

  // Get the first 6 jobs for the latest jobs section
  const latestJobs = jobsData.slice(0, 6);

  return (
    <>
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center hero-bg" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1608991156162-3c55b3cf05d3?auto=format&fit=crop&w=1920&q=80')" }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 leading-tight">Find Your Dream Job in Dubai</h1>
            <h2 className="text-xl md:text-2xl text-gray-200 mb-12 font-light">Discover thousands of job opportunities across UAE</h2>

            {/* Search Form */}
            <div className="bg-white rounded-lg shadow-2xl p-6 md:p-8 mb-8">
              <form action="/jobs" method="get">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  {/* Keywords Input */}
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <i className="fas fa-search text-gray-400"></i>
                    </div>
                    <input type="text" name="keywords"
                           className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none transition-all duration-200"
                           placeholder="Job title, keywords, or company" />
                  </div>

                  {/* Location Select */}
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <i className="fas fa-map-marker-alt text-gray-400"></i>
                    </div>
                    <select name="location"
                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none transition-all duration-200 appearance-none bg-white">
                      <option value="">All Locations</option>
                      <option value="dubai">Dubai</option>
                      <option value="abu-dhabi">Abu Dhabi</option>
                      <option value="sharjah">Sharjah</option>
                      <option value="ajman">Ajman</option>
                      <option value="ras-al-khaimah">Ras Al Khaimah</option>
                    </select>
                  </div>

                  {/* Category Select */}
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <i className="fas fa-briefcase text-gray-400"></i>
                    </div>
                    <select name="category"
                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none transition-all duration-200 appearance-none bg-white">
                      <option value="">All Categories</option>
                      <option value="it">IT & Technology</option>
                      <option value="healthcare">Healthcare</option>
                      <option value="hospitality">Hospitality</option>
                      <option value="finance">Finance</option>
                      <option value="education">Education</option>
                    </select>
                  </div>

                  {/* Search Button */}
                  <button type="submit"
                          className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2">
                    Find Jobs
                  </button>
                </div>
              </form>
            </div>

            {/* Popular Searches */}
            <div className="flex flex-wrap items-center justify-center gap-2 text-white">
              <span className="text-gray-300 font-medium">Popular Searches:</span>
              <Link to="/jobs?keywords=developer" className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-full text-sm transition-all duration-200">Developer</Link>
              <Link to="/jobs?keywords=nurse" className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-full text-sm transition-all duration-200">Nurse</Link>
              <Link to="/jobs?keywords=accountant" className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-full text-sm transition-all duration-200">Accountant</Link>
              <Link to="/jobs?keywords=teacher" className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-full text-sm transition-all duration-200">Teacher</Link>
              <Link to="/jobs?keywords=driver" className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-full text-sm transition-all duration-200">Driver</Link>
            </div>
          </div>
        </div>

        {/* Scroll Down Indicator */}
        <a href="#job-categories" className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white text-center hover:text-gray-300 transition-colors duration-200">
          <div className="flex flex-col items-center">
            <span className="text-sm font-medium mb-2 tracking-wider">EXPLORE</span>
            <i className="fas fa-chevron-down animate-bounce"></i>
          </div>
        </a>
      </section>

      {/* Ad Banner Below Hero */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-8">
        <iframe 
          border="0" 
          src="https://www.trip.com/partners/ad/SB5794672?Allianceid=6648580&SID=228113005&trip_sub1=" 
          style={{width:'300px', height:'250px'}} 
          frameBorder="0" 
          scrolling="no" 
          title="Trip.com Advertisement"
        ></iframe>
      </div>

      {/* Job Categories Section */}
      <section id="job-categories" className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Popular Job Categories</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Explore jobs by category and find the perfect role for your career</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {/* Category 1 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-briefcase text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">All Jobs</h3>
              <p className="text-gray-600 mb-4">10,000+ Jobs Available</p>
              <Link to="/jobs" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 2 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-building text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Top Organizations</h3>
              <p className="text-gray-600 mb-4">5,000+ Companies</p>
              <Link to="/organizations" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 3 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-landmark text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Government Jobs</h3>
              <p className="text-gray-600 mb-4">850+ Jobs Available</p>
              <Link to="/government" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 4 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-stethoscope text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hospital Jobs</h3>
              <p className="text-gray-600 mb-4">920+ Jobs Available</p>
              <Link to="/categories?cat=hospital" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 5 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-hotel text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hotel Jobs in Dubai</h3>
              <p className="text-gray-600 mb-4">750+ Jobs Available</p>
              <Link to="/categories?cat=hotel&location=dubai" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 6 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-shopping-cart text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Supermarket Jobs</h3>
              <p className="text-gray-600 mb-4">680+ Jobs Available</p>
              <Link to="/categories?cat=supermarket" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 7 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-plane text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Airport</h3>
              <p className="text-gray-600 mb-4">520+ Jobs Available</p>
              <Link to="/categories?cat=airport" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 8 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-university text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Banking Jobs</h3>
              <p className="text-gray-600 mb-4">630+ Jobs Available</p>
              <Link to="/categories?cat=banking" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>
          </div>


        </div>
      </section>

      {/* Dubai Skyline Image Section */}
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Discover Opportunities in Dubai</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Find your dream career in one of the world's most dynamic cities</p>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1920&q=80" alt="Dubai Skyline" className="w-full h-auto object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6 text-center">
              <p className="text-white text-lg font-medium">Dubai's iconic skyline - home to thousands of career opportunities</p>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Jobs Section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Latest Job Openings</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Explore the newest opportunities added to our platform</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {latestJobs.map((job) => (
              <div 
                key={job.id} 
                className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer" 
                onClick={() => {
                  // Convert job title to slug
                  const slug = slugify(job.title);
                  window.location.href = `/job-details/${slug}`;
                }}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <img 
                        src={`https://placehold.co/80x80?text=${job.company.charAt(0)}`} 
                        alt={`${job.company} Logo`} 
                        className="w-8 h-8 object-contain bg-primary-100 rounded text-primary-600 font-bold" 
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        <Link to={`/job-details/${slugify(job.title)}`} className="hover:text-primary-600 transition-colors">
                          {job.title}
                        </Link>
                      </h3>
                      <div className="flex items-center text-gray-600 text-sm">
                        <i className="fas fa-building mr-1"></i>
                        <span>
                          <Link to={`/organization/${slugify(job.company)}`} className="hover:text-primary-600 transition-colors">
                            {job.company}
                          </Link>
                        </span>
                      </div>
                    </div>
                  </div>
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    job.type === 'Full Time' ? 'bg-green-100 text-green-800' : 
                    job.type === 'Part Time' ? 'bg-blue-100 text-blue-800' : 
                    'bg-yellow-100 text-yellow-800'
                  }`}>
                    {job.type}
                  </span>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-map-marker-alt mr-2 w-4"></i>
                    <span>{job.location}</span>
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-money-bill-wave mr-2 w-4"></i>
                    <span>{job.salary}</span>
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-clock mr-2 w-4"></i>
                    <span>Posted {job.posted}</span>
                  </div>
                </div>

                <p className="text-gray-600 text-sm mb-6 line-clamp-2">{job.description.substring(0, 100)}...</p>

                <div className="flex items-center justify-between">
                  <Link to={`/job-details/${slugify(job.title)}`} className="inline-flex items-center px-4 py-2 border border-primary-600 text-primary-600 text-sm font-medium rounded-lg hover:bg-primary-600 hover:text-white transition-colors duration-200">
                    View Details
                  </Link>
                  <button className="p-2 text-gray-400 hover:text-primary-600 transition-colors duration-200">
                    <i className="far fa-bookmark"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>


        </div>
      </section>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center hero-bg" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1608991156162-3c55b3cf05d3?auto=format&fit=crop&w=1920&q=80')" }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 leading-tight">Find Your Dream Job in Dubai</h1>
            <h2 className="text-xl md:text-2xl text-gray-200 mb-12 font-light">Discover thousands of job opportunities across UAE</h2>

            {/* Search Form */}
            <div className="bg-white rounded-lg shadow-2xl p-6 md:p-8 mb-8">
              <form action="/jobs" method="get">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  {/* Keywords Input */}
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <i className="fas fa-search text-gray-400"></i>
                    </div>
                    <input type="text" name="keywords"
                           className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none transition-all duration-200"
                           placeholder="Job title, keywords, or company" />
                  </div>

                  {/* Location Select */}
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <i className="fas fa-map-marker-alt text-gray-400"></i>
                    </div>
                    <select name="location"
                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none transition-all duration-200 appearance-none bg-white">
                      <option value="">All Locations</option>
                      <option value="dubai">Dubai</option>
                      <option value="abu-dhabi">Abu Dhabi</option>
                      <option value="sharjah">Sharjah</option>
                      <option value="ajman">Ajman</option>
                      <option value="ras-al-khaimah">Ras Al Khaimah</option>
                    </select>
                  </div>

                  {/* Category Select */}
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <i className="fas fa-briefcase text-gray-400"></i>
                    </div>
                    <select name="category"
                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none transition-all duration-200 appearance-none bg-white">
                      <option value="">All Categories</option>
                      <option value="it">IT & Technology</option>
                      <option value="healthcare">Healthcare</option>
                      <option value="hospitality">Hospitality</option>
                      <option value="finance">Finance</option>
                      <option value="education">Education</option>
                    </select>
                  </div>

                  {/* Search Button */}
                  <button type="submit"
                          className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2">
                    Find Jobs
                  </button>
                </div>
              </form>
            </div>

            {/* Popular Searches */}
            <div className="flex flex-wrap items-center justify-center gap-2 text-white">
              <span className="text-gray-300 font-medium">Popular Searches:</span>
              <Link to="/jobs?keywords=developer" className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-full text-sm transition-all duration-200">Developer</Link>
              <Link to="/jobs?keywords=nurse" className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-full text-sm transition-all duration-200">Nurse</Link>
              <Link to="/jobs?keywords=accountant" className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-full text-sm transition-all duration-200">Accountant</Link>
              <Link to="/jobs?keywords=teacher" className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-full text-sm transition-all duration-200">Teacher</Link>
              <Link to="/jobs?keywords=driver" className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-full text-sm transition-all duration-200">Driver</Link>
            </div>
          </div>
        </div>

        {/* Scroll Down Indicator */}
        <a href="#job-categories" className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white text-center hover:text-gray-300 transition-colors duration-200">
          <div className="flex flex-col items-center">
            <span className="text-sm font-medium mb-2 tracking-wider">EXPLORE</span>
            <i className="fas fa-chevron-down animate-bounce"></i>
          </div>
        </a>
      </section>

      {/* Job Categories Section */}
      <section id="job-categories" className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Popular Job Categories</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Explore jobs by category and find the perfect role for your career</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {/* Category 1 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-briefcase text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">All Jobs</h3>
              <p className="text-gray-600 mb-4">10,000+ Jobs Available</p>
              <Link to="/jobs" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 2 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-building text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Top Organizations</h3>
              <p className="text-gray-600 mb-4">5,000+ Companies</p>
              <Link to="/organizations" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 3 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-landmark text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Government Jobs</h3>
              <p className="text-gray-600 mb-4">850+ Jobs Available</p>
              <Link to="/government" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 4 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-stethoscope text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hospital Jobs</h3>
              <p className="text-gray-600 mb-4">920+ Jobs Available</p>
              <Link to="/categories?cat=hospital" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 5 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-hotel text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hotel Jobs in Dubai</h3>
              <p className="text-gray-600 mb-4">750+ Jobs Available</p>
              <Link to="/categories?cat=hotel&location=dubai" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 6 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-shopping-cart text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Supermarket Jobs</h3>
              <p className="text-gray-600 mb-4">680+ Jobs Available</p>
              <Link to="/categories?cat=supermarket" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 7 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-plane text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Airport</h3>
              <p className="text-gray-600 mb-4">520+ Jobs Available</p>
              <Link to="/categories?cat=airport" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Category 8 */}
            <div className="group bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-primary-500 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className="fas fa-university text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Banking Jobs</h3>
              <p className="text-gray-600 mb-4">630+ Jobs Available</p>
              <Link to="/categories?cat=banking" className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200">
                Browse Jobs <i className="fas fa-arrow-right ml-2 transform group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Dubai Skyline Image Section */}
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Discover Opportunities in Dubai</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Find your dream career in one of the world's most dynamic cities</p>
          </div>
          
          {/* Ad Banner 1 */}
          <div className="ad-banner text-center mb-12">
            <iframe 
              border="0" 
              src="https://www.trip.com/partners/ad/SB5794672?Allianceid=6648580&SID=228113005&trip_sub1=" 
              style={{width:'300px', height:'250px'}} 
              frameBorder="0" 
              scrolling="no" 
              title="Trip.com Advertisement"
            ></iframe>
          </div>
          
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1920&q=80" alt="Dubai Skyline" className="w-full h-auto object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6 text-center">
              <p className="text-white text-lg font-medium">Dubai's iconic skyline - home to thousands of career opportunities</p>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Jobs Section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Latest Job Openings</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Explore the newest opportunities added to our platform</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {latestJobs.map((job) => (
              <div 
                key={job.id} 
                className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer" 
                onClick={() => {
                  // Convert job title to slug
                  const slug = slugify(job.title);
                  window.location.href = `/job-details/${slug}`;
                }}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <img 
                        src={`https://placehold.co/80x80?text=${job.company.charAt(0)}`} 
                        alt={`${job.company} Logo`} 
                        className="w-8 h-8 object-contain bg-primary-100 rounded text-primary-600 font-bold" 
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        <Link to={`/job-details/${slugify(job.title)}`} className="hover:text-primary-600 transition-colors">
                          {job.title}
                        </Link>
                      </h3>
                      <div className="flex items-center text-gray-600 text-sm">
                        <i className="fas fa-building mr-1"></i>
                        <span>
                          <Link to={`/organization/${slugify(job.company)}`} className="hover:text-primary-600 transition-colors">
                            {job.company}
                          </Link>
                        </span>
                      </div>
                    </div>
                  </div>
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    job.type === 'Full Time' ? 'bg-green-100 text-green-800' : 
                    job.type === 'Part Time' ? 'bg-blue-100 text-blue-800' : 
                    'bg-yellow-100 text-yellow-800'
                  }`}>
                    {job.type}
                  </span>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-map-marker-alt mr-2 w-4"></i>
                    <span>{job.location}</span>
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-money-bill-wave mr-2 w-4"></i>
                    <span>{job.salary}</span>
                  </div>
                  <div className="flex items-center text-gray-600 text-sm">
                    <i className="fas fa-clock mr-2 w-4"></i>
                    <span>Posted {job.posted}</span>
                  </div>
                </div>

                <p className="text-gray-600 text-sm mb-6 line-clamp-2">{job.description.substring(0, 100)}...</p>

                <div className="flex items-center justify-between">
                  <Link to={`/job-details/${slugify(job.title)}`} className="inline-flex items-center px-4 py-2 border border-primary-600 text-primary-600 text-sm font-medium rounded-lg hover:bg-primary-600 hover:text-white transition-colors duration-200">
                    View Details
                  </Link>
                  <button className="p-2 text-gray-400 hover:text-primary-600 transition-colors duration-200">
                    <i className="far fa-bookmark"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">How JobsDriver Works</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Simple steps to find your dream job or the perfect candidate</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Step 1 */}
            <div className="relative text-center">
              <div className="relative inline-flex items-center justify-center w-16 h-16 bg-primary-600 text-white rounded-full text-2xl font-bold mb-6">
                1
              </div>
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-user-plus text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Create an Account</h3>
              <p className="text-gray-600">Sign up for free and complete your profile to get started on your job search journey.</p>
            </div>

            {/* Step 2 */}
            <div className="relative text-center">
              <div className="relative inline-flex items-center justify-center w-16 h-16 bg-primary-600 text-white rounded-full text-2xl font-bold mb-6">
                2
              </div>
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-search text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Search Jobs</h3>
              <p className="text-gray-600">Browse thousands of job listings or use our advanced search to find the perfect match.</p>
            </div>

            {/* Step 3 */}
            <div className="relative text-center">
              <div className="relative inline-flex items-center justify-center w-16 h-16 bg-primary-600 text-white rounded-full text-2xl font-bold mb-6">
                3
              </div>
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-file-alt text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Apply for Jobs</h3>
              <p className="text-gray-600">Submit your application with just a few clicks and track your application status.</p>
            </div>

            {/* Step 4 */}
            <div className="relative text-center">
              <div className="relative inline-flex items-center justify-center w-16 h-16 bg-primary-600 text-white rounded-full text-2xl font-bold mb-6">
                4
              </div>
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-handshake text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Get Hired</h3>
              <p className="text-gray-600">Interview with employers and land your dream job in Dubai and across the UAE.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Ad Banner 2 */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="ad-banner text-center mb-12">
            <iframe 
              border="0" 
              src="https://www.trip.com/partners/ad/SB5794672?Allianceid=6648580&SID=228113005&trip_sub1=" 
              style={{width:'300px', height:'250px'}} 
              frameBorder="0" 
              scrolling="no" 
              title="Trip.com Advertisement"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 lg:py-24 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-briefcase text-2xl text-white"></i>
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">10,000+</div>
              <div className="text-primary-100 font-medium">Jobs Available</div>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-building text-2xl text-white"></i>
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">5,000+</div>
              <div className="text-primary-100 font-medium">Companies</div>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-users text-2xl text-white"></i>
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">25,000+</div>
              <div className="text-primary-100 font-medium">Job Seekers</div>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-handshake text-2xl text-white"></i>
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">8,500+</div>
              <div className="text-primary-100 font-medium">Successful Hires</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-16 lg:py-24 bg-gray-900" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1920&q=80')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Ready to Take the Next Step in Your Career?</h2>
          <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">Join thousands of job seekers who have found their dream jobs through JobsDriver</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/register" className="inline-flex items-center px-8 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-all duration-200 transform hover:scale-105">
              Create Account
            </Link>
            <Link to="/jobs" className="inline-flex items-center px-8 py-3 border-2 border-white text-white hover:bg-white hover:text-gray-900 font-semibold rounded-lg transition-all duration-200 transform hover:scale-105">
              Browse Jobs
            </Link>
          </div>
        </div>
      </section>

      {/* Ad Banner 3 */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="ad-banner text-center mb-12">
            <iframe 
              border="0" 
              src="https://www.trip.com/partners/ad/SB5794672?Allianceid=6648580&SID=228113005&trip_sub1=" 
              style={{width:'300px', height:'250px'}} 
              frameBorder="0" 
              scrolling="no" 
              title="Trip.com Advertisement"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Ad Banner 4 */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="ad-banner text-center mb-12">
            <iframe 
              border="0" 
              src="https://www.trip.com/partners/ad/SB5794672?Allianceid=6648580&SID=228113005&trip_sub1=" 
              style={{width:'300px', height:'250px'}} 
              frameBorder="0" 
              scrolling="no" 
              title="Trip.com Advertisement"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 lg:py-24 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-briefcase text-2xl text-white"></i>
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">10,000+</div>
              <div className="text-primary-100 font-medium">Jobs Available</div>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-building text-2xl text-white"></i>
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">5,000+</div>
              <div className="text-primary-100 font-medium">Companies</div>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-users text-2xl text-white"></i>
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">25,000+</div>
              <div className="text-primary-100 font-medium">Job Seekers</div>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-handshake text-2xl text-white"></i>
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">8,500+</div>
              <div className="text-primary-100 font-medium">Successful Hires</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-16 lg:py-24 bg-gray-900" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1920&q=80')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Ready to Take the Next Step in Your Career?</h2>
          <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">Join thousands of job seekers who have found their dream jobs through JobsDriver</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/register" className="inline-flex items-center px-8 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-all duration-200 transform hover:scale-105">
              Create Account
            </Link>
            <Link to="/jobs" className="inline-flex items-center px-8 py-3 border-2 border-white text-white hover:bg-white hover:text-gray-900 font-semibold rounded-lg transition-all duration-200 transform hover:scale-105">
              Browse Jobs
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;